

import React, { useState, useRef } from "react";
import { useCalendar } from "./CalenderContext";
import { AddEventModal, UpdateEventModal, AllEventMiniModal, AllEventDetailModal } from "./AddEventModal";

const WeekView = () => {
  const {
    currentMonth,
    handleDayClick,
    selectedDate,
    daysOfWeek,
    todayDate,
    todayMonth,
    todayYear,
    handleClickOnEventName,
    withStopPropagation,
    showModal,
    setShowModal,
    showModalupdate,
    setShowModalupdate,
    selectedTimeSlot,
    timeSlots,
    isShowAllEventDatemini,
    setShowAllEventDatemini,
    handleShowAllEvent,
    selectedEventmini,
    handleShowAllEventDetail,
    setShowModaldetail,
    showModaldetail,
    handleShowAllUpdate,
    SelectedEventDetail,
    selectedEventupdate,
    setselectedTimeSlot,
    setSelectedDate,
    meetingData,
    getMeetingData,
    Handlecloseallmodal
  } = useCalendar();

  const [dayPosition, setDayPosition] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [selectedDay, setSelectedDay] = useState(null);
  const eventClickRef = useRef(false);



  // Get the days of the current week
  const getWeekDays = () => {
    const currentDate = new Date(selectedDate);
    const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 1 = Monday, etc.

    // Calculate how many days to subtract to get to Monday (if dayOfWeek is 0 (Sunday), we subtract 6)
    const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;

    // Set the date to the previous or current Monday
    currentDate.setDate(currentDate.getDate() + diff);

    const weekDays = [];

    // Generate the days of the week (7 days starting from Monday)
    for (let i = 0; i < 7; i++) {
      const date = new Date(currentDate); // Create a copy of currentDate
      date.setDate(currentDate.getDate() + i); // Adjust the date to the correct day
      weekDays.push(date); // Add the date to the weekDays array
    }

    return weekDays;
  };



  const weekDays = getWeekDays();

  // Handle time slot click
  const handleTimeSlotClickWithPosition = (day, hour, minute, event) => {
    event.stopPropagation();

    setSelectedDay(day);

    // Format the date from the day
    const selectedDateStr = day.toISOString().split('T')[0]; // YYYY-MM-DD format

    // Set the start time at the clicked hour
    const startTime = `${String(hour).padStart(2, "0")}`;

    // Set the end time one hour later
    const endHour = (hour + 1) % 24; // Handle 24-hour wrap around
    const endTime = `${String(endHour).padStart(2, "0")}`;

    // Get AM/PM format for display purposes
    const startPeriod = hour < 12 ? 'AM' : 'PM';
    const endPeriod = endHour < 12 ? 'AM' : 'PM';
    // const startHour12 = hour % 12 || 12; // Convert to 12-hour format
    // const endHour12 = endHour % 12 || 12; // Convert to 12-hour format

    // Create a combined selected time slot object
    const timeSlotData = {

      start: `${startTime}:00`,
      end: `${endTime}:00`,

    };

    setselectedTimeSlot(timeSlotData)

    // Get the position of the clicked time slot
    const rect = event.currentTarget.getBoundingClientRect();
    const position = {
      x: rect.left,
      y: rect.top,
    };

    setDayPosition(position);
    setShowModal(true); // Open the modal
    setSelectedDate(day)
  };

  const handleEventClick = (e, event, day) => {
    eventClickRef.current = true;
    e.stopPropagation();
    e.preventDefault();
    handleShowAllEventDetail(e, event);
  };

  const handleMoreClick = (e, events, day) => {
    eventClickRef.current = true;
    e.stopPropagation();
    e.preventDefault();
    handleShowAllEvent(e, events);
  };



  // Filter events for a specific day and time slot
  // Filter events for a specific day and time slot
  const getEventsForTimeSlot = (day, hour, minute) => {
    const dayDate = day.toISOString().split('T')[0]; // Format: YYYY-MM-DD

    return meetingData.length > 0 && meetingData?.filter((event) => {
      // Check if the event is on the same day
      if (event.meeting_date !== dayDate) {
        return false;
      }

      // Parse the event start time
      const [eventHour, eventMinute] = event.start_time.split(':').map(Number);

      // Match by hour and minute (if minute is provided)
      if (minute !== undefined) {
        return eventHour === hour && eventMinute === minute;
      }

      // Match by hour only
      return eventHour === hour;
    });
  };

  // Render events for a specific day and time slot
  const renderEvents = (day, hour, minute) => {
    const maxEventsToShow = 1;
    const eventsAtTime = getEventsForTimeSlot(day, hour, minute);
    const more = eventsAtTime.length - maxEventsToShow;

    return (
      <>
        {eventsAtTime.length > 0 && eventsAtTime.slice(0, maxEventsToShow).map((event, index) => (
          <div key={index} onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}>
            <div
              className="event-name"
              onClick={(e) => handleEventClick(e, event, day)}
              onMouseDown={(e) => {
                eventClickRef.current = true;
                e.stopPropagation();
              }}

            >
              {event.title || "Untitled"}
              <AllEventDetailModal
                showModal={showModaldetail}
                onClose={() => setShowModaldetail(false)}
                selectedEvent={[event]}
                dayPosition={dayPosition}
                showModalupdate={showModalupdate}
                setShowModalupdate={setShowModalupdate}
                handleShowAllUpdate={handleShowAllUpdate}
                timeSlots={timeSlots}
                selectedTimeSlot={selectedTimeSlot}
                setShowModaldetail={setShowModaldetail}
              />
            </div>
          </div>
        ))}

        {more > 0 && (
          <div className="relative" onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}>
            <div
              onClick={(e) => handleMoreClick(e, eventsAtTime, day)}
              onMouseDown={(e) => {
                eventClickRef.current = true;
                e.stopPropagation();
              }}
              className="event-name see-more-btn w-max"

            >
              {more} more...
              <AllEventMiniModal
                showModal={isShowAllEventDatemini}
                onClose={() => {
                  setShowAllEventDatemini(false);
                  setShowModal(false);
                }}
                dayPosition={dayPosition}
                selectedEventmini={selectedEventmini}
                showModaldetail={showModaldetail}
                timeSlots={timeSlots}
                selectedTimeSlot={selectedTimeSlot}
                setShowModaldetail={setShowModaldetail}
                handleShowAllEventDetail={handleShowAllEventDetail}
                handleShowAllUpdate={handleShowAllUpdate}
                selectedDate={selectedDate}
              />
            </div>
          </div>
        )}
      </>
    );
  };

  // Format date for the week header
  const formatDayHeader = (date) => {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return `${days[date.getDay()]} ${date.getDate()}`;
  };

  // Check if a date is today
  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  return (
    <div className="week-view">
      {/* Week Header */}
      <div className="week-header">
        <div className="time-gutter" style={{ width: "60px" }}>
          {/* Empty cell for time gutter */}
        </div>
        {weekDays.map((day, index) => (
          <div
            key={index}
            className={`day-column-header ${isToday(day) ? 'today' : ''}`}
            style={{
              flex: 1,
              textAlign: 'center',
              padding: '8px 0',
              borderBottom: '1px solid #ddd',
              // backgroundColor: isToday(day) ? '#f0f8ff' : 'transparent',
              // fontWeight: isToday(day) ? 'bold' : 'normal'
            }}
          >
            <span style={{ color: `${isToday(day) ? 'black' : ''}` }}>{formatDayHeader(day)}</span>
          </div>
        ))}
      </div>

      {/* Time Grid */}
      <div className="time-grid" style={{ display: 'flex', flexDirection: 'row' }}>
        {/* Time Gutter */}
        <div className="time-gutter" style={{ width: "60px" }}>
          {Array.from({ length: 24 }, (_, hour) => ({
            hour,
            minute: 0, // Set minutes to 0 for one-hour intervals
          })).map((slot, index) => {
            const { hour, minute } = slot;
            if (minute === 0) { // Only show hour labels
              const hour12 = hour % 12 || 12;
              const ampm = hour < 12 ? "AM" : "PM";
              return (
                <div
                  key={index}
                  className="time-label"

                >
                  {`${hour12} ${ampm}`}
                </div>
              );
            }
            return null;
          })}
        </div>

        {/* Day Columns */}
        {weekDays.map((day, dayIndex) => (
          <div
            key={dayIndex}
            className="day-column"
            style={{
              flex: 1,
              // backgroundColor: isToday(day) ? '#f0f8ff' : 'transparent'
            }}
          >
            {Array.from({ length: 24 }, (_, hour) => ({
              hour,
              minute: 0, // Set minutes to 0 for one-hour intervals
            })).map((slot, slotIndex) => {
              const { hour, minute } = slot;
              return (
                <div
                  key={slotIndex}
                  className={`time-slot ${minute === 0 ? 'hour-slot' : ''}`}
                  onClick={(event) => handleTimeSlotClickWithPosition(day, hour, minute, event)}
                  style={{
                    height: minute === 0 ? "60px" : "15px",
                    borderBottom: minute === 0 ? "1px solid #ddd" : "1px solid #f5f5f5",
                    position: "relative"
                  }}
                >
                  {/* Render events for this time slot */}
                  <div className="events">
                    {renderEvents(day, hour, minute)}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {console.log(selectedTimeSlot)}
      <AddEventModal
        showModal={showModal}
        onClose={() => setShowModal(false)}
        dayPosition={dayPosition}
        timeSlots={timeSlots}
        selectedTimeslot={selectedTimeSlot}
        selectedDate={selectedDate}
        getMeetingData={getMeetingData}
        Handlecloseallmodal={Handlecloseallmodal}
      />
      <UpdateEventModal
        showModal={showModalupdate}
        onClose={() => setShowModalupdate(false)}
        dayPosition={dayPosition}
        timeSlots={timeSlots}
        selectedTimeslot={selectedTimeSlot}
        selectedEvent={selectedEventupdate}
        getMeetingData={getMeetingData}
        Handlecloseallmodal={Handlecloseallmodal}
      />

    </div>
  );
};

export default WeekView;
